var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHalfColumn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.93 16.86H9.93C9.41894 16.8574 8.92956 16.6532 8.56819 16.2918C8.20681 15.9304 8.00263 15.4411 8 14.93V9.93C8.00263 9.41894 8.20681 8.92956 8.56819 8.56819C8.92956 8.20681 9.41894 8.00263 9.93 8H14.93C15.4411 8.00263 15.9304 8.20681 16.2918 8.56819C16.6532 8.92956 16.8574 9.41894 16.86 9.93V14.93C16.8574 15.4411 16.6532 15.9304 16.2918 16.2918C15.9304 16.6532 15.4411 16.8574 14.93 16.86ZM9.93 9.5C9.81596 9.5 9.70658 9.5453 9.62594 9.62594C9.5453 9.70658 9.5 9.81596 9.5 9.93V14.93C9.5 15.044 9.5453 15.1534 9.62594 15.2341C9.70658 15.3147 9.81596 15.36 9.93 15.36H14.93C15.044 15.36 15.1534 15.3147 15.2341 15.2341C15.3147 15.1534 15.36 15.044 15.36 14.93V9.93C15.36 9.81596 15.3147 9.70658 15.2341 9.62594C15.1534 9.5453 15.044 9.5 14.93 9.5H9.93Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfColumn);
export default __webpack_public_path__ + "static/media/half-column.7c92bc7d33b06fe75f7d637e8e03ccea.svg";
export { ForwardRef as ReactComponent };